import React from 'react';
import { FormField } from '../../../../components/FormField';
import { FormRow } from '../../../../components/FormRow';

interface PromotionCommercialProps {
  formData: any;
  property?: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
}

export const PromotionCommercial: React.FC<PromotionCommercialProps> = ({
  formData,
  property,
  handleInputChange,
}) => {
  return (
    <div className="space-y-4">
      <h4 className="font-medium text-gray-900 dark:text-white">Informations commerciales</h4>

      <FormRow>
        <FormField label="Type de commercialisation">
          <select
            name="commercialization_type"
            value={property?.commercialization_type || formData.commercialization_type || ''}
            onChange={handleInputChange}
            className="w-full"
          >
            <option value="">Sélectionner</option>
            <option value="vente sur plan">Vente sur plan (VEFA)</option>
            <option value="vente achevée">Vente achevée</option>
          </select>
        </FormField>

        <FormField label="Mode de paiement">
          <select
            name="payment_method"
            value={property?.payment_method || formData.payment_method || ''}
            onChange={handleInputChange}
            className="w-full"
          >
            <option value="">Sélectionner</option>
            <option value="comptant">Paiement comptant</option>
            <option value="échelonné">Paiement échelonné</option>
            <option value="crédit bancaire">Crédit bancaire</option>
            <option value="mixte">Mixte</option>
          </select>
        </FormField>
      </FormRow>

      {formData.commercialization_type === 'vente sur plan' && (
        <FormField label="Taux d'avancement pour paiements (%)">
          <input
            type="number"
            name="completion_rate_for_payment"
            value={property?.completion_rate_for_payment ?? formData.completion_rate_for_payment ?? 0}
            onChange={handleInputChange}
            min="0"
            max="100"
            placeholder="0"
          />
        </FormField>
      )}

      <FormField label="Disponibilité des lots">
        <textarea
          name="lots_availability"
          value={property?.lots_availability || formData.lots_availability || ''}
          onChange={handleInputChange}
          rows={3}
          placeholder="Ex: 10 lots en vente, 5 réservés, 3 vendus"
          className="w-full"
        />
      </FormField>

      {formData.payment_method === 'échelonné' && (
        <FormField label="Échéancier de paiement">
          <textarea
            name="payment_schedule"
            value={property?.payment_schedule || formData.payment_schedule || ''}
            onChange={handleInputChange}
            rows={4}
            placeholder="Ex: 20% à la réservation, 30% au gros œuvre, 50% à la livraison"
            className="w-full"
          />
        </FormField>
      )}
    </div>
  );
};
